import { useTranslation } from "react-i18next";
import { getStorytellingRomanLabel } from "./storytellingPresentation";

function StorytellingChapterTitleField({
  index,
  chapterLabel,
  updateStorytellingField,
}) {
  const { t } = useTranslation();
  const romanLabel = getStorytellingRomanLabel(index);

  return (
    <div>
      <label
        className="form-label text-primary"
        htmlFor={`storytelling-chapter-label-${index}`}
      >
        {t("storytellingChapterLabelField")}
      </label>
      <div className="storytelling-chapter-title-field">
        <span
          className="storytelling-chapter-title-field__roman"
          aria-hidden="true"
        >
          {romanLabel}
        </span>
        <input
          id={`storytelling-chapter-label-${index}`}
          type="text"
          className="form-control storytelling-chapter-title-field__input"
          value={chapterLabel || ""}
          placeholder={t("storytellingChapterTitlePlaceholder")}
          onChange={(e) =>
            updateStorytellingField(index, "chapterLabel", e.target.value)
          }
        />
      </div>
      <small className="text-muted d-block mt-1">
        {t("storytellingChapterLabelHint", { roman: romanLabel })}
      </small>
    </div>
  );
}

export default StorytellingChapterTitleField;
